import {
  differenceInHours,
  format,
  isSameDay,
  subMilliseconds,
} from 'date-fns';
import { DateRange, localEquivalentOfUTC, NullableDate } from 'mapistry-shared';
import React from 'react';
import { NoWrap } from './styled';

function formatDate(date: Date) {
  return format(date, 'P');
}

function areDatesHourly(begin: Date, end: Date): boolean {
  const HOURS_IN_A_DAY = 24;
  // An exclusive day interval goes from 00:00 AM - 23:59 PM which IS < 24 hours.
  // And there can be some offset as a result of the way that date-fns calculates differenceInHours,
  // so to be safe let's compare it to 24 - 2.
  // This works for now because the smallest date ranges we allow here are either daily or hourly.
  // If we ever start allowing date ranges that are 22 hours long, let's revisit this.
  return differenceInHours(end, begin) < HOURS_IN_A_DAY - 2;
}

function formatBoundedDateRange(beginDate: Date, endDate: Date): string {
  // Hourly date range
  if (areDatesHourly(beginDate, endDate)) {
    return `${format(beginDate, 'Pp')} - ${format(endDate, 'p')}`;
  }
  // Single day date range
  if (isSameDay(beginDate, endDate)) {
    return formatDate(beginDate);
  }
  // Different day date range
  return `${formatDate(beginDate)} - ${formatDate(endDate)}`;
}

function formatUnboundedDateRange(
  begin: NullableDate,
  end: NullableDate,
): string {
  if (begin && !end) {
    return `After ${formatDate(begin)}`;
  }
  if (!begin && end) {
    return `Before ${formatDate(end)}`;
  }
  return 'All time';
}

export const DateRangeTableCell = ({ value }: { value: DateRange }) => {
  const begin =
    value.begin != null ? localEquivalentOfUTC(new Date(value.begin)) : null;
  const end =
    value.end != null
      ? localEquivalentOfUTC(subMilliseconds(new Date(value.end), 1))
      : null;

  const formated =
    begin && end
      ? formatBoundedDateRange(begin, end)
      : formatUnboundedDateRange(begin, end);

  return <NoWrap>{formated}</NoWrap>;
};
